import React, { useContext as useContextCore } from 'react'
import styles from './styles.module.scss'

export type ProviderProps = { children: React.ReactNode; activeStep: number }

export type ContextType = {
  canRun: (stepIndex: number) => boolean
  getClassName: (stepIndex: number) => string
} & Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const Provider = ({ children, activeStep }: ProviderProps) => {
  const getClassName = (stepIndex: number) => {
    const status = `${activeStep === stepIndex ? styles.current : ''} ${activeStep > stepIndex ? styles.done : ''}`
    const isDisabled = stepIndex > activeStep + 1 ? styles.disabled : ''
    return `${status} ${isDisabled}`
  }

  const canRun = (stepIndex: number) => {
    return !(activeStep <= stepIndex && (activeStep ?? 0) + 1 !== stepIndex)
  }

  return <CoreProvider value={{ getClassName, canRun, activeStep }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
